// banner.jsx



// src/site/components/banner.jsx
import React from "react";
import AgendexScreeenShotCRM from '../../Assets/agendex/agendex-crm.png';
import './banner.css';

function Banner() {
  return (
    <section id="banner" className="py-5 bg-primary text-white">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1 className="display-5 fw-bold">Pare de perder clientes por falta de organização.</h1>
            <p className="lead">Agende, lembre e fature mais — tudo em um só lugar, sem complicação.</p>
            <p>Mais de 1.200 profissionais já usam o Agendex para reduzir faltas e aumentar agendamentos.</p>
            <div className="d-grid gap-2 d-md-flex">
              <a href="/app/novaconta/prestador" className="btn btn-light btn-lg px-4 me-md-2">Começar grátis (14 dias)</a>
              <a href="#preco" className="btn btn-outline-light btn-lg px-4">Ver planos</a>
            </div>
          </div>
          <div className="col-lg-6 text-center">
            <img 
              src={AgendexScreeenShotCRM} 
              alt="Demonstração da agenda do Agendex" 
              className="img-fluid rounded shadow"
              style={{ maxWidth: '90%' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
export default Banner;